import WarrantForm from './calculator-form-warrants';
import TurboBoosterForm from './calculator-form-turbo-booster';
import CappeFlooreForm from './calculator-form-cappe-floore';

const forms = {
	warrant: WarrantForm,
	cappeFloore: CappeFlooreForm,
	cappedBonus: CappeFlooreForm,
	default: TurboBoosterForm,
};

const formFactory = (el, type) => {
	const isinField = el.querySelector('[name="isin"]');

	if (!isinField || !isinField.value) {
		throw Error('The form element needs an isin field with a value');
	}

	const FormClass = forms.hasOwnProperty(type) ? forms[type] : forms.default;

	return new FormClass(el);
};

export default formFactory;
